import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo4/mapapais.png";
import Arrow from "../../../images/arrow.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo4 } from "../../../routes/Module4";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo4/Actividad 1.mp3";

const Actividad1 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "CHINA" },
    ans2: { value: "", valid: "", correctValue: "ESTADOS UNIDOS" },
    ans3: { value: "", valid: "", correctValue: "INDIA" },
  });
  const infoUnidad = modulo4.content[0];
  const infoAct = modulo4.content[0].activities[0];
  const crumbs = [
    {
      title: modulo4.title,
      url: "/" + modulo4.url,
    },
    {
      title:
        modulo4.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo4.content[0].activities[1].name}`,
    linkNext: `${modulo4.url}/${modulo4.content[0].path}/${modulo4.content[0].activities[1].path}`,
    titlePrev: modulo4.title,
    linkPrev: modulo4.url,
  };
  const metadata = {
    color: modulo4.color,
    title: `${modulo4.title} - ${infoAct.name}`,
    name: modulo4.title,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div className="row">
        <div className="col-lg-8 col-12">
          <p>
            <small className={`c-${modulo4.color} hat-text`}>
              <FontAwesomeIcon icon={faEye} /> Observamos
            </small>
          </p>
          <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

          <ul>
            <li>
              ¡En el mundo viven más de 7 mil millones de personas! Todos somos
              diferentes y es un reto vivir juntos.
            </li>
            <li>
              Observa el mapa que aparece abajo. Los países marcados son los que
              tienen más habitantes.
            </li>
            <li>
              Con la ayuda de tu profesor, profesora o familiar, escribe sus nombres.
            </li>
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8 col-12 position-relative">
          <input
            type="text"
            id="country-1"
            className={"form-control " + answers.ans1.valid}
            value={answers.ans1.value}
            onChange={(event) => handleAnswers(event, "ans1")}
          />
          <input
            type="text"
            id="country-2"
            className={"form-control " + answers.ans2.valid}
            value={answers.ans2.value}
            onChange={(event) => handleAnswers(event, "ans2")}
          />
          <input
            type="text"
            id="country-3"
            className={"form-control " + answers.ans3.valid}
            value={answers.ans3.value}
            onChange={(event) => handleAnswers(event, "ans3")}
          />

          <img src={Imagen1} className="img-fluid" alt="Grupo" />
          <img src={Arrow} className="arrow-1" alt="Grupo" />
          <img src={Arrow} className="arrow-2" alt="Grupo" />
          <img src={Arrow} className="arrow-3" alt="Grupo" />

        </div>
        <div className="d-flex w-100 justify-content-center mb-4">
          <button
            className={`btn btn-${modulo4.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>

      <ul>
        <li>Tu país se encuentra marcado de color morado, ubicalo y escribe su nombre.</li>
      </ul>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes. Ayude a identificar los
          continentes y algunos países. Destaque que hay igual proporción de
          hombres y mujeres en el mundo y que niños y niñas conforman un tercio
          del total. Ayude con los nombres de los países marcados: China, India,
          Estados Unidos.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
